import LogoDSCrm from "../../../assets/preload/logo-fidelize.png";
import LogoDSMarketing from "../../../assets/header/DsMarketing.png";
import IconDeliveryVip from "../../../assets/header/deliveryvip.png";
import { useStyles } from "../styles";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { MenuButtonHeader } from "../../../components/MenuButtonHeader";
import { useCallback, useState } from "react";
import { useAuth } from "../../../hooks/useAuth";
import { AppsRounded } from "@mui/icons-material";
import { NewIconButtonMenu } from "../../../components/NewIconButtonMenu";
import axios from "axios";
import { useToast } from "../../../hooks/useToast";

export function LeftHeader() {
  const { token } = useAuth();
  const styles = useStyles();
  const navigate = useNavigate();
  const toast = useToast();

  const [company] = useState(
    JSON.parse(localStorage.getItem("@datasales:user")!)
  );

  const handleGoToDsMarketing = useCallback(() => {
    const urlDsMarketing = `https://app.datasales.info/sign-as-user/${token}`;
    window.location.assign(urlDsMarketing);
  }, [token]);

  const handleGoToDeliveryVip = useCallback(async () => {
    if (company.deliveryVip) {
      try {
        const loginVip = await axios.post(
          `https://api-backoffice.datasales.info/p2-dev/login/magicLink`,
          {
            memberId: company.deliveryVip.memberId,
            merchantId: company.deliveryVip.merchantId,
          }
        );
        window.open(`${loginVip.data.magic_link}`);
      } catch (e) {
        toast.show("Credencias inválidas", {
          severity: "warning",
        });
      }
    } else {
      toast.show("Você não possui acesso a essa funcionalidade", {
        severity: "warning",
      });
    }
  }, [company, toast]);

  return (
    <div id="header-block-left" className={styles.rootLeft}>
      <NewIconButtonMenu
        className={styles.iconBtn}
        color="default"
        aria-label="apps"
        size="small"
        onClick={() => navigate("/form-delivery")}
        options={[
          {
            title: "Aplicativos DS",
            icon: LogoDSMarketing,
            label: "ds.marketing",
            onClick: handleGoToDsMarketing,
          },
          {
            title: "Aplicativos de Parceiros",
            icon: IconDeliveryVip,
            label: "delivery Vip",
            onClick: handleGoToDeliveryVip,
          },
        ]}
      >
        <AppsRounded />
      </NewIconButtonMenu>

      <img
        id="logo-ds-plus"
        className={styles.image}
        src={LogoDSCrm}
        alt="ds-plus"
      />

      <Button
        id="btn-init"
        onClick={() => navigate("/")}
        className={styles.btnOptions}
        variant="text"
      >
        Início
      </Button>
      <MenuButtonHeader
        id="btn-apps"
        className={styles.btnOptions}
        variant="text"
        label="Aplicativos"
        options={[
          { label: "Importação de dados", onClick: () => navigate("imports") },
          { label: "Exportação de dados", onClick: () => navigate("exports") },
          {
            label: "Enriquecimento de dados",
            onClick: () => navigate("enrichment"),
          },
          { label: "Formulários", onClick: () => navigate("forms") },
        ]}
      />
      <MenuButtonHeader
        id="btn-apps"
        className={styles.btnOptions}
        variant="text"
        label="BI"
        options={[
          {
            label: "Resultados das campanhas",
            options: [
              {
                label: "Disparo em canais digitais",
                onClick: () => navigate("results"),
              },
              {
                label: "Descontos personalizados",
                onClick: () => navigate("results-offers"),
              },
            ],
            key: "results",
          },
          { label: "Visões personalizadas", onClick: () => navigate("bi") },
        ]}
      />
      <MenuButtonHeader
        id="btn-settings"
        className={styles.btnOptions}
        variant="text"
        label="Configurar"
        options={[{ label: "WhatsApp", onClick: () => navigate("whatsapp") }]}
      />
      <MenuButtonHeader
        id="btn-help"
        className={styles.btnOptions}
        variant="text"
        label="Suporte"
        options={[
          {
            label: "Base de conhecimento",
            onClick: () => window.open("https://datasales.stonly.com/kb/pt/"),
          },

          {
            label: "Falar com suporte",
            onClick: () =>
              window.open(
                "https://datasales.stonly.com/kb/pt/entre-em-contato-121583"
              ),
          },
        ]}
      />
    </div>
  );
}
